import { render, staticRenderFns } from "./materia_authorize.vue?vue&type=template&id=086778e5&scoped=true"
import script from "./materia_authorize.vue?vue&type=script&lang=ts"
export * from "./materia_authorize.vue?vue&type=script&lang=ts"
import style0 from "./materia_authorize.vue?vue&type=style&index=0&id=086778e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086778e5",
  null
  
)

export default component.exports